import React from "react";

interface SearchJobsFilterProps {
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  jobStatusMap: Record<string, string>;
  jobStatusList: string[];
  loading?: boolean;
  onRefresh?: () => void;
  onSearchClick: () => void;
}

const SearchJobsFilter: React.FC<SearchJobsFilterProps> = ({
  searchTerm,
  onSearchTermChange,
  statusFilter,
  onStatusFilterChange,
  jobStatusMap,
  jobStatusList,
    loading = false,
    onSearchClick,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
      <div>
        <label
          htmlFor="search"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Search Jobs
        </label>
        <input
          type="text"
          id="search"
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          placeholder="Search by title, department, or location..."
            disabled={loading}
        />
      </div>
      <div>
        <label
          htmlFor="status"
          className="block text-sm font-medium text-gray-700 mb-2"
        >
          Status Filter
        </label>
        <select
          id="status"
          value={statusFilter}
          onChange={(e) => {
            e.preventDefault();
            onStatusFilterChange(e.target.value);
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
          disabled={loading}
        >
          <option value="all">All Statuses</option>
          {jobStatusList.map((type) => (
            <option key={type} value={type}>
              {jobStatusMap[type]}
            </option>
          ))}
        </select>
      </div>
      <div className="flex items-end">
        <button
          onClick={onSearchClick}
          className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          disabled={loading}
        >
          {loading ? 'Searching...' : 'Search'}
        </button>
      </div>
      {/* Uncomment to enable refresh button */}
      {/* <div className="flex items-end">
        <button
          onClick={onRefresh}
          className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500"
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Refresh'}
        </button>
      </div> */}
    </div>
  );
};

export default SearchJobsFilter;
